var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gray-gradient",attrs:{"id":"business"}},[_c('navbar',{attrs:{"data":1}}),_c('intro'),_c('popular-bundles'),_c('random-offers'),_c('MtnApps'),_c('special-services'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }